export default __webpack_public_path__ + "static/media/room-2.7f9a32a0.jpg";